(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landing-faq-accordion')) {
    customElements.define(
      'landing-faq-accordion',
      class LandingFaqAccordion extends HTMLElement {
        connectedCallback() {
          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);
          this.syncPanels();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        onClick(event) {
          const trigger = event.target.closest('[data-landing-faq-trigger]');

          if (!trigger || !this.contains(trigger)) {
            return;
          }

          const item = trigger.closest('.landing-faq-item');

          if (!item) {
            return;
          }

          const isOpen = item.classList.contains('is-open');

          this.querySelectorAll('.landing-faq-item').forEach((sibling) => {
            sibling.classList.remove('is-open');
            const siblingTrigger = sibling.querySelector('[data-landing-faq-trigger]');

            if (siblingTrigger) {
              siblingTrigger.setAttribute('aria-expanded', 'false');
            }
          });

          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }

          this.syncPanels();
        }

        syncPanels() {
          this.querySelectorAll('.landing-faq-item').forEach((item) => {
            const panel = item.querySelector('.landing-faq-item__panel');
            const isOpen = item.classList.contains('is-open');

            if (panel) {
              panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            }
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
